import { useMemo } from 'react'
import AnnotationCommentModalRN from 'pages/building/panoramas/components/rn/AnnotationCommentModalRN'
import { useRecoilValue } from 'recoil'
import { currentAnnotation } from 'store/krpanoStore'
import { AnnotationType } from 'types/building'

import AnnotationModal from '../AnnotationModal/AnnotationModal'

export default function RNViewerAnnotationModal() {
  const currentSelected = useRecoilValue(currentAnnotation)

  const isComment = useMemo(() => {
    if (!currentSelected) return false
    const selectedAny = currentSelected as any
    const typeVal = selectedAny.type
    return (
      Number(typeVal) === Number(AnnotationType.COMMENT) ||
      typeVal === 'COMMENT' ||
      typeVal === '42' ||
      Boolean(
        selectedAny.comment_object ||
          selectedAny.commentObject ||
          selectedAny.comment
      )
    )
  }, [currentSelected])

  if (!currentSelected) return null

  if (isComment) {
    return <AnnotationCommentModalRN />
  }

  return <AnnotationModal />
}
